/* Copyright (c) 2020-present CloudIO Inc */

// Copy this file to src/componentregistry/components/Popup folder

import { Item } from 'componentregistry';

export const page: {
  root: Item<'Page'>;
  popup: Item<'Popup'>;
  button: Item<'Button'>;
  button1: Item<'Button'>;
  rowPanel: Item<'Box'>;
  columnPanel: Item<'Box'>;
  popupActions: Item<'PopupActions'>;
  triggerOnClick: Item<'TriggerOnClick'>;
  actionOpenPopup: Item<'ActionOpenPopup'>;
  flexPanel: Item<'FlexPanel'>;
  flex1FlexItem: Item<'FlexItem'>;
  triggerOnClick1: Item<'TriggerOnClick'>;
  popupClosePopup: Item<'ActionClosePopup'>;
} = {
  actionOpenPopup: {
    children: [],
    itemId: 'actionOpenPopup',
    parent: 'triggerOnClick',
    props: {
      targetItemId: 'popup',
    },
    type: 'ActionOpenPopup',
  },
  button: {
    children: ['triggerOnClick1'],
    itemId: 'button',
    parent: 'popupActions',
    props: {
      startIcon: {
        iconName: 'check',
        iconType: 'light',
      },
      text: {
        type: 'text',
        value: 'Close',
      },
    },
    type: 'Button',
  },
  button1: {
    children: ['triggerOnClick'],
    itemId: 'button1',
    parent: 'columnPanel',
    props: {
      startIcon: {
        iconName: 'window-restore',
        iconType: 'light',
      },
      text: {
        type: 'text',
        value: 'Open Popup',
      },
    },
    type: 'Button',
  },
  columnPanel: {
    children: ['button1'],
    itemId: 'columnPanel',
    parent: 'rowPanel',
    props: {},
    type: 'Box',
  },
  flex1FlexItem: {
    children: ['rowPanel'],
    itemId: 'flex1FlexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flex1FlexItem'],
    itemId: 'flexPanel',
    parent: 'root',
    props: {},
    type: 'FlexPanel',
  },
  popup: {
    children: ['popupActions'],
    itemId: 'popup',
    parent: 'root',
    props: {
      modal: true,
      title: {
        type: 'text',
        value: 'Awesome Title',
      },
    },
    type: 'Popup',
  },
  popupActions: {
    children: ['button'],
    itemId: 'popupActions',
    parent: 'popup',
    props: {},
    type: 'PopupActions',
  },
  popupClosePopup: {
    children: [],
    itemId: 'popupClosePopup',
    parent: 'triggerOnClick1',
    props: {
      targetItemId: 'popup',
    },
    type: 'ActionClosePopup',
  },
  root: {
    children: ['popup', 'flexPanel'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
  rowPanel: {
    children: ['columnPanel'],
    itemId: 'rowPanel',
    parent: 'flex1FlexItem',
    props: {
      boxHeight: '1',
    },
    type: 'Box',
  },
  triggerOnClick: {
    children: ['actionOpenPopup'],
    itemId: 'triggerOnClick',
    parent: 'button1',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick1: {
    children: ['popupClosePopup'],
    itemId: 'triggerOnClick1',
    parent: 'button',
    props: {},
    type: 'TriggerOnClick',
  },
};
